import React, { useEffect, useState } from "react";
import { useAuth, isTrial } from "../../contexts/AuthContext";
import { Alert, Box, Button, Link, Snackbar, Typography } from "@mui/material";
import { InvokeAPI } from "../../apis/API";
import { getUserMgmtBase } from "../../config/apiBase";
import { useNavigate } from "react-router-dom";

function Trialbanner() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const [isActivationInProgress, setIsActivationInProgress] = useState(false);

    const getActivationStatus = async () => {
        const response = await InvokeAPI(
            `${getUserMgmtBase()}/v1/user/enroll/activation-status`,
            {
                "UserID": user["id"],
            },
            'POST',
            { "authorization": user["token"] },
            false
        );
        if (response["unauthenticated"] == true || response["unauthorized"] == true || response["othererror"] == true) {
            return;
        }
        if (response.response && response.response["IsInProgress"] === true) {
            setIsActivationInProgress(true);
        } else {
            setIsActivationInProgress(false);
        }
    };

    useEffect(() => {
        if (user["accountState"] == "trial" && user && user["id"]) {
            getActivationStatus();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    return (
        <>
            {isTrial() ?
                <Box 
                    display="flex" 
                    justifyContent="center" 
                    alignItems="center" 
                    textAlign="center" 
                    sx={{ 
                        padding: '6px 16px', 
                        width: '100%', 
                        zIndex: 1000, 
                        position: 'fixed', 
                        bottom: '0', 
                        background: 'linear-gradient(135deg, #ed6c02 0%, #e65100 100%)',
                        color: 'white',
                        boxShadow: '0 -4px 20px rgba(0,0,0,0.2)',
                        animation: 'slideUp 0.4s ease-out',
                        '@keyframes slideUp': {
                            from: {
                                opacity: 0,
                                transform: 'translateY(100%)',
                            },
                            to: {
                                opacity: 1,
                                transform: 'translateY(0)',
                            },
                        },
                    }}
                >
                    <Typography sx={{ flexGrow: 1, mr: 2, fontWeight: 500, fontSize: '0.875rem', lineHeight: 1.2 }}>
                        You are in Trial period. &nbsp; &nbsp;
                        <Button  
                        onClick={(e)=>{e.preventDefault();navigate("/app/activate")}} 
                        type="submit" 
                        variant="contained" 
                        color={isActivationInProgress ? "primary" : "success"}
                        disabled={isActivationInProgress}
                        size="small"
                        sx={{ 
                            minWidth: '140px',
                            fontSize: '0.875rem',
                            py: 0.5,
                            px: 2,
                            height: '32px',
                            ...(isActivationInProgress ? {
                                backgroundColor: 'primary.main',
                                color: 'primary.contrastText',
                                opacity: 1,
                                '&.Mui-disabled': {
                                    backgroundColor: 'primary.main',
                                    color: 'primary.contrastText',
                                    opacity: 0.8,
                                },
                            } : {
                                backgroundColor: '#2e7d32',
                                '&:hover': {
                                    backgroundColor: '#1b5e20',
                                    transform: 'translateY(-2px)',
                                    boxShadow: (theme) => theme.shadows[8],
                                },
                            }),
                            transition: 'all 0.2s ease-in-out',
                        }}
                    >
                        {isActivationInProgress ? "Your account activation is in progress" : "Click To Activate"}
                    </Button>
                    </Typography>
                  
                </Box>
                : <></>
            }
        </>
    );
}

export default Trialbanner;